/**
 * @description: 会员余额结转报表
 * @author: lyr
*/
<template>
    <div class="mr-yejz-report">
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable clearable placeholder="请选择门店" @change="changeShop">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList">查询</el-button>
                    <el-button @click="getYejzExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="before_total_amount" label="期初余额"></el-table-column>
                <el-table-column prop="before_account" label="通用账户余额"></el-table-column>
                <el-table-column prop="before_present_account" label="赠送账户余额"></el-table-column>
                <el-table-column prop="before_room_account" label="房费账户余额"></el-table-column>
                <el-table-column prop="recharge_total_amount" label="充值总额"></el-table-column>
                <el-table-column prop="recharge_account" label="通用账户充值"></el-table-column>
                <el-table-column prop="recharge_present_account" label="赠送账户充值"></el-table-column>
                <el-table-column prop="recharge_room_account" label="房费账户充值"></el-table-column>
                <el-table-column prop="expend_total_amount" label="消费总额"></el-table-column>
                <el-table-column prop="expend_account" label="通用账户消费"></el-table-column>
                <el-table-column prop="expend_present_account" label="赠送账户消费"></el-table-column>
                <el-table-column prop="expend_room_account" label="房费账户消费"></el-table-column>
                <el-table-column prop="after_total_amount" label="期末余额"></el-table-column>
                <el-table-column prop="after_account" label="通用账户余额"></el-table-column>
                <el-table-column prop="after_present_account" label="赠送账户余额"></el-table-column>
                <el-table-column prop="after_room_account" label="房费账户余额"></el-table-column>
            </el-table>
        </div>
        <!-- 导出设置弹窗 -->
        <div class="ele-hide" ref="yejzExport_alert">
            <div class="set-export sel-seldiv">
                <h3>请选择导出报表需要的显示的字段</h3>
                <ul class="set-area clearfix">
                    <li>
                        <input type='checkbox' v-model='yejzExport_allcheck' @click='yejzExportCheckedAll'>
                        <label>全选</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="before_total_amount">
                        <label>期初余额</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="before_account">
                        <label>通用账户余额</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="before_present_account">
                        <label>赠送账户余额</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="before_room_account">
                        <label>房费账户余额</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="recharge_total_amount">
                        <label>充值总额</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="recharge_account">
                        <label>通用账户充值</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="recharge_present_account">
                        <label>赠送账户充值</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="recharge_room_account">
                        <label>房费账户充值</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="expend_total_amount">
                        <label>消费总额</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="expend_account">
                        <label>通用账户消费</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="expend_present_account">
                        <label>赠送账户消费</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="expend_room_account">
                        <label>房费账户消费</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="after_total_amount">
                        <label>期末余额</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="after_account">
                        <label>通用账户余额</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="after_present_account">
                        <label>赠送账户余额</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='yejzExport_checkModel' value="after_room_account">
                        <label>房费账户余额</label>
                    </li>
                </ul>
                <h3>请选择导出报表的文件格式</h3>
                <ul class="clearfix">
                    <li>
                        <input type="radio" v-model='yejzExport_type' value="1">
                        <label>excel表格</label>
                    </li>
                    <li>
                        <input type="radio" v-model='yejzExport_type' value="2">
                        <label>pdf文件</label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'yejz-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                vip_list: [],
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                },
                list_table: [],
                yejzExport_allcheck: false,
                c_yejzExport_allcheck: false,
                yejzExport_checkModel: [],
                yejzExport_checkData: ['before_total_amount', 'before_account', 'before_present_account', 'before_room_account', 'recharge_total_amount', 'recharge_account', 'recharge_present_account', 'recharge_room_account', 'expend_total_amount', 'expend_account', 'expend_present_account', 'expend_room_account', 'after_total_amount', 'after_account', 'after_present_account', 'after_room_account'],
                yejzExport_type: 1,
            }
        },
        watch: {
            yejzExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.yejzExport_checkModel.length >= this.yejzExport_checkData.length) {
                        this.yejzExport_allcheck = true;
                        this.c_yejzExport_allcheck = true;
                    } else {
                        this.yejzExport_allcheck = false;
                        this.c_yejzExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD 08:00');
            this.innitDate();
            
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                if (this.$route.params.shareholder_vip_card) { // 页面跳转第一次打开
                    this.list_form.shop_id = ''
                }else {
                    this.list_form.shop_id = this.shop_list[0].id;
                }
                this.getList();
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').toDate(),
                    endDate: moment().toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },

            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            changeShop(val) {
                if (!!val) {
                    this.setShopDefaultTime(val)
                }
            },

            getList() {
                const _this = this;

                Vue.axios.post('Vip/getvipCarriedForward', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "start_time": _this.list_form.start_time,
                            "end_time": _this.list_form.end_time,
                            "shop_id": _this.list_form.shop_id,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.list_table = []
                        _this.list_table.push(res.data.response.result);
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 获取导出设置
            getYejzExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "Vip/exportvipCarriedForward"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.yejzExport_checkModel = data.response.result.export_fields;
                                _this.yejzExport_type = data.response.result.export_type;
                            } else {
                                _this.yejzExport_checkModel = _this.yejzExport_checkData;
                                _this.yejzExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.yejzExport_alert)
                }, function() {
                    _this.exportYejzList();
                });
            },
            // 导出字段全选
            yejzExportCheckedAll: function() {
                let _this = this;
                _this.yejzExport_allcheck = _this.c_yejzExport_allcheck;
                if(!_this.yejzExport_allcheck) { // 实现全选
                    _this.yejzExport_checkModel = [];
                    _this.yejzExport_checkData.forEach(function(item) {
                        _this.yejzExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.yejzExport_checkModel = [];
                }
            },
            // 确定“导出”
            exportYejzList: function() {
                let export_fields = JSON.stringify(this.yejzExport_checkModel);
                window.location.href = Vue.ctUrl + "Vip/exportvipCarriedForward?" +
                    "&start_time=" + this.list_form.start_time +
                    "&end_time=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&export_fields=" + export_fields +
                    "&export_type=" + this.yejzExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },

        }
    }
</script>
<style lang="less" scoped>

</style>